// import { DocumentReference } from 'firebase/firestore';
import { BaseModel, BaseModelKeys } from '../base.model';

export enum LookupKeys {
  value = 'value',
  description = 'description',
  isSystem = 'isSystem',
  isActive = 'isActive',
  isAssigned = 'isAssigned',
  dependsOn = 'dependsOn',
  visible = 'visible',
  reference = 'reference',
  isDefault = 'isDefault',
  orderBy = 'orderBy',
}

export class ValueDescription {
  [LookupKeys.value]!: string | number | Date;
  [LookupKeys.description]!: string;
}

export class Lookup extends BaseModel {
  [LookupKeys.value]: string | null = null;
  [LookupKeys.description]: string | null = null;
  [LookupKeys.dependsOn]?: string = '';
  [LookupKeys.isSystem]: boolean = false;
  [LookupKeys.isAssigned]: boolean = false;
  [LookupKeys.isActive]: boolean = true;
  [LookupKeys.isDefault]?: boolean = false;
  [LookupKeys.orderBy]?: number;
  [LookupKeys.reference]: any; // DocumentReference<Lookup>;
}

export class ActiveLookup {
  [BaseModelKeys.dbId]!: string;
  [LookupKeys.value]!: string;
  [LookupKeys.description]!: string;
  [LookupKeys.visible]!: boolean;
  [LookupKeys.isDefault]?: boolean;
  [LookupKeys.orderBy]?: number;
}
